import strFunc from "@/lib/lyg/string";

class PageListFunc {
  static get_info_arr_added_money_sum(inData: any) {
    let opt_obj = {
      infoArr: [],
      ...inData
    };
    let tmp_info_arr: any = opt_obj.infoArr;
    for (let info_i = 0; info_i < tmp_info_arr.length; info_i++) {
      let info = tmp_info_arr[info_i];
      let tmp_added_supply_money_sum = 0;
      if (info.supply_arr) {
        for (let i = 0; i < info.supply_arr.length; i++) {
          let row_supply_info = info.supply_arr[i];
          tmp_added_supply_money_sum += parseInt(strFunc.uncomma(row_supply_info["a_money_sum"]));
        }
      }

      info.added_supply_money_sum = tmp_added_supply_money_sum;
      tmp_info_arr[info_i] = info;
    }
    return tmp_info_arr;
  }
  static get_ordered_by_supply(inData: any) {
    let opt_obj = {
      infoArr: [],
      ...inData
    };
    let change_infoArr: any = [];
    let pay_ing_info_arr=[];
    let pay_info_arr = [];
    //납부완료는 밑으로보낸다.
    for (let i = 0; i < opt_obj.infoArr.length; i++) {
      let info = opt_obj.infoArr[i];
      if (!strFunc.is_empty(info["added_supply_money_sum"])){
        if(info.supply_data
        && info["added_supply_money_sum"] == info.supply_data.a_money_sum){
          pay_info_arr.push(info);
        }else{
          pay_ing_info_arr.push(info);
        }
      } else {
        change_infoArr.push(info);
      }
    }
    let infoArr = [
      ...change_infoArr,
      ...pay_ing_info_arr,
      ...pay_info_arr
    ];
    return infoArr;
  }
};
export default PageListFunc;